import React from "react";

const AdsterraBanner = ({ width = "100%", height = "250px" }) => {
  return (
    <div
      style={{
        width: width,
        height: height,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <ins className="adsbyadsterra" style={{ display: "block", width: "100%", height: "100%" }}></ins>
    </div>
  );
};

export default AdsterraBanner;
